<template>
    <div>
        <v-layout>
            <v-flex>
                <div id="reportList" v-if="display=='report'">
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12 lg12 xl12 style="margin: auto">
                            <div id="divStudents">
                                <v-data-table :headers="reportHeaders" :items="reports" class="elevation-1"
                                              hide-actions>
                                    <template slot="items" slot-scope="props">
                                        <td class="text-xs-left">{{ props.index +1 }}</td>
                                        <td class="text-xs-left">{{getReportType( props.item.reportType )}}</td>
                                        <td class="text-xs-left">{{ props.item.reportName }}</td>
                                        <td class="text-xs-left" v-if="$store.state.auth.user.role!=2">{{ props.item.reportDate | formatDateTime }}</td>
                                        <td class="text-xs-left" v-if="$store.state.auth.user.role!=2">{{ getReportStatus(props.item.status)}}</td>
                                        <td class="justify-center layout px-0">
                                            <v-btn @click="viewReport(props.item)" class="mx-0" icon>
                                                <v-icon class="primaryColor">visibility</v-icon>
                                            </v-btn>
                                            <v-btn @click="updateReport(props.item)" class="mx-0" icon v-if="$store.state.auth.user.role==4">
                                                <v-icon color="pink">edit</v-icon>
                                            </v-btn>
                                        </td>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
                <div id="memberList" v-else-if="display=='list'">
                    <v-layout>
                        <v-flex xs12 sm12 md12 lg12 xl12 class="yocontent">
                            <div style="text-align: center;font-weight: bold">KẾT QUẢ HỌC TẬP - Môn
                                {{reportMeta.class.disciplineName}}
                            </div>
                            <div style="text-align: center">Kì {{reportMeta.term}} Năm {{reportMeta.year}}</div>
                            <div>Lớp: {{reportMeta.class.className}}</div>
                            <div>Giáo viên: {{reportMeta.teacher}}</div>
                            <div>Học sinh điểm xếp hạng nhất lớp: {{reportMeta.firstStudent}}</div>
                            <div>Học sinh điểm xếp hạng nhì lớp: {{reportMeta.secondStudent}}</div>
                            <div>Học sinh điểm xếp hạng ba lớp: {{reportMeta.thirdStudent}}</div>
                            <v-data-table :headers="detailReportHeaders" class="elevation-1"
                                          :items="reportData" hide-actions locale="vi">
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-right">{{ props.index+1}}</td>
                                    <td class="text-xs-left">{{ props.item["fullName"] }}</td>
                                    <td class="text-xs-right">{{ props.item["markAverage"] }}</td>
                                    <td class="text-xs-right">{{ props.item["rank"] }}</td>
                                    <td class="text-xs-right">
                                        <div v-if="editReport==false">
                                            {{ props.item["markTarget"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text" style="text-align: right"
                                               v-model='props.item["markTarget"]'/>
                                    </td>
                                    <td class="text-xs-left">
                                        <div v-if="editReport==false">
                                            {{ props.item["evaluate"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text" style="text-align: right"
                                               v-model='props.item["evaluate"]' list="evaluateSuggest"/>
                                    <td class="text-xs-left">
                                        <div v-if="editReport==false">
                                            {{ props.item["teacherComment"] }}
                                        </div>
                                        <input class="tableInput" v-else type="text" style="text-align: right"
                                               v-model='props.item["teacherComment"]'/>
                                    </td>
                                </template>
                            </v-data-table>
                            <datalist id="evaluateSuggest">
                                <option value="Đạt"/>
                                <option value="Chưa đạt"/>
                            </datalist>
                        </v-flex>
                    </v-layout>
                    <div style="text-align: right">
                        <v-btn color="primary" @click="onExportReport">
                            {{$t('lang.common.exportReport') }}
                        </v-btn>
                        <v-btn class="blue" dark @click="onSend" v-if="!editReport && $store.state.auth.user.role==4">
                            {{$t('lang.class.send')}}
                        </v-btn>
                        <v-btn class="yoprimary" dark @click="editReport = true" v-if="!editReport && $store.state.auth.user.role==4">
                            {{$t('lang.common.edit')}}
                        </v-btn>
                        <v-btn @click="saveReport()" v-if="editReport && $store.state.auth.user.role==4"
                               class="yoprimary" dark>
                            {{$t('lang.common.save')}}
                        </v-btn>
                        <v-btn @click="closeDetail()" color="red" dark>
                            {{$t('lang.common.back')}}
                        </v-btn>
                    </div>
                </div>
                <send-to-member :class-id="classId" @send="onChangeReceiver" ref="sendDialog" :selectable="false"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import SendToMember from "../sendToMember";

    export default {
        name: "quarter-report-page",
        components: {SendToMember},
        props: {
            classId: {
                type: String | Number,
                default: null
            }
        },

        data: () => ({
            display: "report",
            editReport: false,
            year: null,
            term: null,
            studentHeaders: [
                {
                    text: "Sinh viên",
                    align: "left",
                    sortable: false,
                    value: "fullName"
                },
                {
                    text: "email",
                    align: "left",
                    sortable: false,
                    value: "email"
                },
                {text: "Báo cáo chi tiết", value: "name", align: "center", sortable: false}
            ],
            students: [],
            reportData: [],
            reportMeta: {},
            workingReport: null,
            reports: [],
            exerciseId: null,
            exerciseType: null,
            averateMark: null,
        }),

        computed: {
            detailReportHeaders: function () {
                if (this.editReport) {
                    return [
                        {
                            text: "STT",
                            align: "right",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "HỌ TÊN",
                            align: "left",
                            sortable: false,
                            value: "fullName"
                        },
                        {
                            text: "ĐIỂM TRUNG BÌNH",
                            align: "right",
                            sortable: false,
                            value: "markAverage"
                        },
                        {
                            text: "THỨ HẠNG",
                            align: "right",
                            sortable: false,
                            value: "rank"
                        },
                        {
                            text: "MỤC TIÊU ĐIỂM SỐ",
                            align: "right",
                            sortable: false,
                            value: "markTarget"
                        },
                        {
                            text: "ĐÁNH GIÁ SO VỚI MỤC TIÊU",
                            align: "left",
                            sortable: false,
                            value: "evaluate"
                        },
                        {
                            text: "NHẬN XÉT",
                            align: "left",
                            sortable: false,
                            value: "teacherComment"
                        }
                    ]
                } else {
                    return [
                        {
                            text: "STT",
                            align: "right",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "HỌ TÊN",
                            align: "left",
                            sortable: false,
                            value: "fullName"
                        },
                        {
                            text: "ĐIỂM TRUNG BÌNH",
                            align: "right",
                            sortable: false,
                            value: "markAverage"
                        },
                        {
                            text: "THỨ HẠNG",
                            align: "right",
                            sortable: false,
                            value: "rank"
                        },
                        {
                            text: "MỤC TIÊU ĐIỂM SỐ",
                            align: "right",
                            sortable: false,
                            value: "markTarget"
                        },
                        {
                            text: "ĐÁNH GIÁ SO VỚI MỤC TIÊU",
                            align: "left",
                            sortable: false,
                            value: "evaluate"
                        },
                        {
                            text: "NHẬN XÉT",
                            align: "left",
                            sortable: false,
                            value: "teacherComment"
                        }
                    ]
                }
            },
            reportHeaders(){
                if(this.$store.state.auth.user.role==2){
                    return [
                        {
                            text: "STT",
                            align: "left",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Loại báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportType"
                        },
                        {
                            text: "Tên báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportName"
                        },
                        {
                            text: "Xử lý",
                            align: "center",
                            sortable: false,
                            value: "status"
                        }
                    ];
                } else {
                    return [
                        {
                            text: "STT",
                            align: "left",
                            sortable: false,
                            value: "index"
                        },
                        {
                            text: "Loại báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportType"
                        },
                        {
                            text: "Tên báo cáo",
                            align: "left",
                            sortable: false,
                            value: "reportName"
                        },
                        {
                            text: "Thời gian cập nhật",
                            align: "left",
                            sortable: false,
                            value: "reportDate"
                        },
                        {
                            text: "Trạng thái",
                            align: "left",
                            sortable: false,
                            value: "status"
                        },
                        {
                            text: "Xử lý",
                            align: "center",
                            sortable: false,
                            value: "status"
                        }
                    ];
                }
            }

        },

        watch: {
            classId: function (data) {
                this.getReportList();
            },
            month: function (data) {
                console.log(data);
            }
        },

        created() {
            //this.getReportList();
        },
        methods: {
            getReportType: function (type) {
                let typeName = "";
                switch (type) {
                    case 0:
                        typeName = "Báo cáo sau bài tập";
                        break;
                    case 1:
                        typeName = "Báo cáo cá nhân";
                        break;
                    case 2:
                        typeName = "Báo cáo tháng";
                        break;
                    case 3:
                        typeName = "Báo cáo kỳ";
                        break;
                }
                return typeName;
            },
            getReportStatus: function (status) {
                let name = "";
                switch (status) {
                    case 0:
                        name = "Chưa cập nhật";
                        break;
                    case 1:
                        name = "Đã cập nhật";
                        break;
                    case 2:
                        name = "Đã gửi";
                        break;
                }
                return name;

            },

            getReportList: function () {
                if (this.classId == null) {
                    return;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/report/listTermReport?classId=" +
                        this.classId
                    )
                    .then(
                        data => {
                            this.reports = data;
                        },
                        error => {
                        }
                    )

            },

            viewReport: function (report) {
                this.year = report.year;
                this.term = report.month;
                this.editReport = false;
                this.display = "list";
                this.workingReport = report;
                this.getMarkReport();
            },

            updateReport: function (report) {
                this.year = report.year;
                this.term = report.month;
                this.editReport = true;
                this.display = "list";
                this.workingReport = report;
                this.getMarkReport();
            },

            getMarkReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/getTermReport?classId=" + this.classId + "&year=" + this.year + "&term=" + this.term)
                    .then(
                        data => {
                            this.reportMeta = data;
                            this.reportData = data.lstData;
                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onExportReport: function () {
                let url = process.env.VUE_APP_API_URL + "/report/downloadTermReport?classId=" + this.classId + "&year=" + this.year + "&term=" + this.term;
                window.location.href = url;
            },

            saveReport: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/saveTermReportData", this.reportData)
                    .then(
                        data => {
                            if (data.success) {
                                axios.post(process.env.VUE_APP_API_URL + "/report/saveReport?", this.workingReport).then(
                                    saveResult => {
                                        if (saveResult.success) {
                                            message.success(this.$t('lang.common.save_success'));
                                            this.workingReport = saveResult.ref;
                                            this.editReport = false;
                                            this.getMarkReport();
                                        }
                                    },

                                    saveError => {
                                        message.error(saveError);

                                    }
                                );

                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )

            },

            closeDetail: function () {
                this.display = "report";
                this.getReportList();
            },

            onSendEmail: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/sendTermEmailReport?classId=" + this.classId + "&year=" + this.year + "&term=" + this.term)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi mail thành công");
                            } else {
                                message.error("Gửi mail không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendSMS: function () {
                axios.post(process.env.VUE_APP_API_URL + "/report/sendTermSMSReport?classId=" + this.classId + "&year=" + this.year + "&term=" + this.term)
                    .then(
                        data => {
                            if (data.success) {
                                message.success("Gửi SMS thành công");
                            } else {
                                message.error("Gửi SMS không thành công");
                            }

                        },
                        error => {
                            message.error(error);
                        }
                    )
            },

            onSendZalo: function () {
                //let url = encodeURIComponent("https://localhost:8082/#/sendZalo/");
                let url = process.env.VUE_APP_FRONTEND_URL + "/#/sendZalo";
                debugger;
                console.log(url);
                let state = this.classId + "_" + this.year + "_" + this.term + "_quarter";
                url = encodeURIComponent(url);
                console.log(url);
                window.location.href = "https://oauth.zaloapp.com/v3/permission?app_id=2865613710705099529&redirect_uri=" + url + "&state=" + state;
            },

            onSend: function () {
                this.$refs.sendDialog.show();
            },

            onChangeReceiver: function (receivers) {
                axios.post(process.env.VUE_APP_API_URL+"/report/sendReport",this.workingReport).then(
                    data=>{
                        if(data.success){
                            this.onSendEmail();
                            this.onSendSMS();
                            //this.onSendZalo();
                            this.workingReport = data.ref;
                        }
                    }
                )
            },
        }
    };
</script>